// 爆仓数据接口
import { post, get } from '~/assets/js/api/methods'

import apiList from '~/env.config'
const { fxServer, fxClient } = apiList

export default axios => ({
  // 爆仓数据首页
  newBrustDataService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/brustdata/slist/init-v1`, params), // 初始化数据(服务端)
  newBrustDataClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/brustdata/slist/init-v1`, params), // 初始化数据(客户端)

  // 爆仓数据详情页
  newBrustDetailForAllService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/brustdata/burst/switch-v1`, params), // 全部(服务端)
  newBrustDetailService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/brustdata/burst/detail-v1`, params), // 单个(服务端)
  newBrustDetailForAllClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/brustdata/burst/switch-v1`, params), // 全部(客户端)
  newBrustDetailClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/brustdata/burst/detail-v1`, params), // 单个(客户端)

  // EA风云榜首页
  newMtRankService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/earanking/index/init-v1`, params), // 表格数据(服务端)
  newMtRankClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/earanking/index/switch-v1`, params), // 表格数据(客户端)

  // EA风云榜详情页
  earankingDetailService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/earanking/detail/init-v1`, params), // 详情初始化(服务端)
  newProfitForDayClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/earanking/detail/profit-v1`, params), // 收益(USD)(客户端)
  newEquityClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/earanking/detail/equity-v1`, params), // 资产走势(USD)(客户端)
  newTradeSymbolClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/earanking/detail/symbol-v1`, params), // 交易品种分析(客户端)

  // 交易环境排行（首页）
  newRakingClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/broker/env/ranking-v1`, params), // 列表(客户端)
  newRakingService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/broker/env/ranking-v1`, params), // 列表(服务端)
  newBrokersService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/broker/list/init-v1`, params), // 对比列表(服务端)

  // 交易环境排行（对比页）
  newContrastService: (params = {}) => post(axios, `${fxServer}/wikifxweb-v1/broker/contrast/init-v1`, params), // 对比列表(服务端)
  newContrastClient: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/broker/contrast/init-v1`, params), // 对比列表(客户端)

  // 交易环境排行（详情页）
  newDetailService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/broker/detail/init-v1`, params), // 详情数据(服务端)

  // vps首页接口
  newRegionInfoV2Service: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/index/init-v1`, params), // vps未购买云主机首页初始化(服务端)
  newUserHost: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/index/host-v1`, params), // 是否购买云主机(服务端)
  newUserHostClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/index/host-v1`, params), // 是否购买云主机(客户端)

  // 已购买云主机首页
  newMyAccount: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/detail/init-v1`, params), // 初始化(服务端)
  newDetectionClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/detail/checkresult-v1`, params), // 检测弹窗接口(客户端)
  newDeleteHost: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/vps/detail/terminate-v1`, params), // 删除主机
  newRebootHost: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/vps/detail/reboot-v1`, params), // 重启主机
  newInstallHost: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/vps/detail/reinstall-v1`, params), // 重装主机
  newResetHostPwd: (params = {}) => post(axios, `${fxClient}/wikifxweb-v1/vps/detail/resetpassword-v1`, params), // 修改主机密码
  newCheckPwd: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/detail/authpassword-v1`, params), // 校验密码格式

  // vps的我的账户
  newAccountInfoService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/init-v1`, params), // 账号详情数据(服务端)
  newMoneyDetailService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/moneydetail-v1`, params), // 出入金(服务端)
  newMoneyDetailClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/account/moneydetail-v1`, params), // 出入金(客户端)
  newCurrentHoldService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/currenthold-v1`, params), // 当前持仓(服务端)
  newCurrentHoldClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/account/currenthold-v1`, params), // 当前持仓(客户端)
  newHistoryHoldService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/historyhold-v1`, params), // 历史单(服务端)
  newHistoryHoldClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/account/historyhold-v1`, params), // 历史单(客户端)
  newProfitService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/profit-v1`, params), // 每月收益(服务端)
  newProfitClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/account/profit-v1`, params), // 每月收益(客户端)
  newequityService: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/account/equity-v1`, params), // 净值走势(服务端)
  newequityClient: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/vps/account/equity-v1`, params) // 净值走势(客户端)
})
